/**
 * @generated SignedSource<<dcdf57e01607981a9d132c41fc0c9d8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MoqStepType = "CUSTOM" | "FIXED";
export type MoqRuleInput = {
  colors: ReadonlyArray<MoqRuleColorInput>;
  customTiers?: string | null;
  fixedStep?: number | null;
  globalColors: ReadonlyArray<string>;
  id?: string | null;
  minimumQuantity: number;
  name: string;
  printTypes: ReadonlyArray<number>;
  products: ReadonlyArray<number>;
  stepType: MoqStepType;
};
export type MoqRuleColorInput = {
  colorID: number;
  productID: number;
};
export type moqRuleEditor_UpdateMoqRuleMutation$variables = {
  input: MoqRuleInput;
};
export type moqRuleEditor_UpdateMoqRuleMutation$data = {
  readonly updateMoqRule: {
    readonly moqRule: {
      readonly customTiers: string;
      readonly fixedStep: number | null;
      readonly id: string;
      readonly minimumQuantity: number;
      readonly name: string;
      readonly stepType: MoqStepType;
    } | null;
  };
};
export type moqRuleEditor_UpdateMoqRuleMutation = {
  response: moqRuleEditor_UpdateMoqRuleMutation$data;
  variables: moqRuleEditor_UpdateMoqRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MoqRuleOutput",
    "kind": "LinkedField",
    "name": "updateMoqRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MoqRule",
        "kind": "LinkedField",
        "name": "moqRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumQuantity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stepType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fixedStep",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customTiers",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moqRuleEditor_UpdateMoqRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moqRuleEditor_UpdateMoqRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f4b0dfadd43d12f9945532f3227c14d3",
    "id": null,
    "metadata": {},
    "name": "moqRuleEditor_UpdateMoqRuleMutation",
    "operationKind": "mutation",
    "text": "mutation moqRuleEditor_UpdateMoqRuleMutation(\n  $input: MoqRuleInput!\n) {\n  updateMoqRule(input: $input) {\n    moqRule {\n      id\n      name\n      minimumQuantity\n      stepType\n      fixedStep\n      customTiers\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9f8c168ab52e8df14568660bc964663";

export default node;
